import { PropsWithChildren } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { JiraServiceManagementLogo } from "@atlaskit/logo";

import { BlueWaveTemplate } from "@/components/signup/layouts";
import { Picture } from "@/components/wpl/image/src";

import { VerizonSquareDominosTwitter } from "./verizon-square-dominos-twitter";

export const BlueWaveTemplateJsm = ({
    productEditionText,
    children
}: PropsWithChildren<{ productEditionText: string }>) => {
    const { formatMessage } = useIntl();

    return (
        <BlueWaveTemplate
            socialProofLogos={<VerizonSquareDominosTwitter />}
            tagline={formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD",
                defaultMessage: "Powering high-velocity service teams"
            })}
            valueProps={formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD",
                defaultMessage:
                    "Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly"
            }).split("{newline}")}
            productLogos={[
                <JiraServiceManagementLogo
                    appearance="inverse"
                    size="xlarge"
                    key="jsm"
                />
            ]}
            illustration={
                <Picture
                    image={{
                        src: "https://atlassian.com/dam/jcr:45864a30-5470-4cbe-be59-9aae63492229/JSD%20Hero.svg",
                        alt: ""
                    }}
                />
            }
            productEditionText={productEditionText}
        >
            <div css={containerCss}>{children}</div>
        </BlueWaveTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "8px"
});
